import { useEffect, useState } from "react";
import useSessions, { SessionProps } from "./useSessions";

const useSession = (sessionID?: string) => {
  const sessions = useSessions();
  const [session, setSession] = useState<SessionProps | undefined>();

  useEffect(() => {
    const fetch = async () => {
      if (sessionID && sessions) {
        const session = sessions.find(
          (session: any) => session.ID === sessionID
        );

        if (session) {
          setSession(session);
        }
      }
    };

    fetch();
  }, [sessionID, sessions]);

  return session;
};

export default useSession;
